import { Box } from "@mui/material";

import styled from "@emotion/styled";

const Title = styled.div`
    min-width: 0;
    font-family: "Nunito", sans-serif;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;

    & a {
        color: inherit;
    }
`;

const Description = styled.div`
    min-width: 0;
    font-family: "Nunito", sans-serif;
    font-size: 13px;
    line-height: 1.45;
    word-break: break-word;

    & a {
        color: inherit;
    }
`;

const NotificationCell = ({ notification }) => {
    const isRead = !!notification.read_at;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.25,
                minWidth: 0,
                width: "100%",
                py: 0.25,
            }}
        >
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <Title
                    style={{
                        fontWeight: isRead ? 600 : 800,
                        color: isRead ? "#555" : "#1a1a1a",
                    }}
                    dangerouslySetInnerHTML={{ __html: notification.title }}
                />
                {notification.description ? (
                    <Description
                        style={{
                            marginTop: 4,
                            color: isRead ? "#999" : "#666",
                        }}
                        dangerouslySetInnerHTML={{
                            __html: notification.description,
                        }}
                    />
                ) : null}
            </Box>
        </Box>
    );
};

export default NotificationCell;
